window._ = require('underscore');
require('src/frontend/old/common/underscore_mixins');
